import React, { useState, useEffect, useRef } from 'react';
import './Tooltip.css';

const Tooltip = ({ 
    children, 
    content,
    wrapperStyle = {},
    tooltipStyle = {}, 
    size = 'nowrap', // sm, md, lg, nowrap
    arrow = true,
    placement = 'right', // top, right, bottom, left, top-start, top-end, right-start, right-end, bottom-start, bottom-end, left-start, left-end
    trigger = 'hover', // hover, click 
    className = ''
  }) => {

  const [visible, setVisible] = useState(false);
  const backgroundColor = tooltipStyle.background || '#1B1925'; // by default black
  const textColor = tooltipStyle.color || 'white'; // by default white
  const tooltipWrapperRef = useRef(null);

  const getSizeClasses = () => {
    switch (size) {
      case 'sm':
        return 'tooltip-sm';
      case 'md':
        return 'tooltip-md';
      case 'lg':
        return 'tooltip-lg';
      case 'nowrap':
        return 'tooltip-no-wrap';
      default:
        return 'tooltip-no-wrap';
    }
  };

  const getPlacementClasses = () => {
    switch (placement) {
      case 'top':
        return 'tooltip-top';
      case 'bottom':
        return 'tooltip-bottom';
      case 'left':
        return 'tooltip-left';
      case 'right':
        return 'tooltip-right';
      case 'top-start':
        return 'tooltip-top-start';
      case 'top-end':
        return 'tooltip-top-end';
      case 'bottom-start':
        return 'tooltip-bottom-start';
      case 'bottom-end':
        return 'tooltip-bottom-end';
      case 'left-start':
        return 'tooltip-left-start';
      case 'left-end':
        return 'tooltip-left-end';
      case 'right-start':
        return 'tooltip-right-start';
      case 'right-end':
        return 'tooltip-right-end';
      default:
        return 'tooltip-right';
    }
  };

  let triggerProps= {};

  switch(trigger) {
    case "hover":
      triggerProps={
        onMouseEnter: () => setVisible(true),
        onMouseLeave: () => setVisible(false)
      };
      break;
    case "click":
      triggerProps={
        onClick: () => setVisible(prev => !prev)
      };
      break;
    default: //hover
      triggerProps={
        onMouseEnter: () => setVisible(true),
        onMouseLeave: () => setVisible(false)
      };
  }

  // Hanle clicking outside for click trigger
  useEffect(() => {
    if (trigger!=='click' || !visible) return;

    const handleClickOutside = (e) => {
      if (tooltipWrapperRef.current && !tooltipWrapperRef.current.contains(e.target)) { // if click is not on tooltip wrapper
        setVisible(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [trigger, visible]);

  return (
    <div 
      style={{...wrapperStyle, position: 'relative', display: 'inline-block' }}
      {...triggerProps}
      ref={tooltipWrapperRef}
    >
      {children}
      {visible && (
        <div 
        style={{...tooltipStyle,
                color: textColor,
                '--tooltip-bg': backgroundColor}}
        className={`tooltip-container ${className} ${getSizeClasses()} ${getPlacementClasses()} ${arrow ? 'with-arrow' : ''}`}
        onClick={(e) => e.stopPropagation()}
        >
          {content}
        </div>
      )}
    </div>
  );
};

export default Tooltip;